import React, { useEffect, useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Button } from './ui/button';
import {
  Popover, PopoverContent, PopoverTrigger,
} from './ui/popover';
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from './ui/command';
import { cn } from '../lib/utils';

/**
 * Searchable account picker (combobox). Type kode atau nama akun untuk filter.
 */
export const AccountCombobox = ({ value, onChange, accounts, testId, placeholder = 'Pilih akun…' }) => {
  const [open, setOpen] = useState(false);
  const selected = accounts.find((a) => a.id === value);

  // Auto-default ke BCA Play Sport Indonesia (1-1101) kalau tersedia di list & belum ada pilihan
  useEffect(() => {
    if (value) return;
    const def = accounts.find((a) => a.code === '1-1101' && !a.is_header);
    if (def) onChange(def.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, value]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full h-9 justify-between bg-white font-normal text-sm px-3"
          data-testid={testId}
        >
          {selected ? (
            <span className="truncate">
              <span className="font-mono text-xs text-stone-500 mr-2">{selected.code}</span>
              {selected.name}
            </span>
          ) : (
            <span className="text-stone-400">{placeholder}</span>
          )}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[360px] p-0 bg-white" align="start">
        <Command
          filter={(id, search) => {
            // id is the CommandItem `value` which we set to `${code} ${name}` — Search matches lowercase
            return id.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
          }}
        >
          <CommandInput placeholder="Cari kode atau nama akun…" data-testid={`${testId}-search`} />
          <CommandList className="max-h-72 overflow-y-auto overscroll-contain">
            <CommandEmpty>Akun tidak ditemukan.</CommandEmpty>
            <CommandGroup>
              {accounts.filter((a) => !a.is_header).map((a) => (
                <CommandItem
                  key={a.id}
                  value={`${a.code} ${a.name}`}
                  onSelect={() => {
                    onChange(a.id);
                    setOpen(false);
                  }}
                  data-testid={`${testId}-opt-${a.code}`}
                  className="cursor-pointer"
                >
                  <Check className={cn('mr-2 h-4 w-4', value === a.id ? 'opacity-100 text-emerald-700' : 'opacity-0')} />
                  <span className="font-mono text-xs text-stone-500 mr-2 w-16">{a.code}</span>
                  <span>{a.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default AccountCombobox;
